import { compose, uniqBy, map, filter, get, identity } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createAsyncActionTypes, createAction } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { ApplicationState, CommanderThunkAction } from '@mews-commander/types';
import { ThreadProfileMembership } from '@mews-commander/messages';
import { getOrEmptyObject } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'threadsMembership';

export const THREADS_MEMBERSHIP_FETCH = prefix('THREADS_MEMBERSHIP_FETCH');
export const [THREADS_MEMBERSHIP_FETCH_STARTED, THREADS_MEMBERSHIP_FETCH_SUCCEEDED, THREADS_MEMBERSHIP_FETCH_FAILED] =
    createAsyncActionTypes(THREADS_MEMBERSHIP_FETCH);

export const [getThreadsMemberships, getThreadsMembershipsByIds, getThreadsMembershipsByOwnerId, getThreadsMembership] =
    createScopedBaseEntitySelectors<ApplicationState, ThreadProfileMembership, typeof NAME, 'enterpriseId'>(
        parentSelector,
        NAME,
        'enterpriseId'
    );

export const getCurrentEnterpriseThreadsMemberships = createSelector(
    getCurrentEnterpriseId,
    identity<ApplicationState>,
    (enterpriseId, state) => getThreadsMemberships(state, { enterpriseId })
);

const getCurrentEnterpriseThreadsMembershipById = createSelector(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    getStringProp('id'),
    getCurrentEnterpriseThreadsMemberships,
    getOrEmptyObject
);

export const getThreadMembershipProfileIds = compose(
    get('membersProfileIds'),
    getCurrentEnterpriseThreadsMembershipById
);

const mapMembers = (data: ThreadProfileMembership[]) =>
    compose(
        map(({ threadId }) => ({
            id: threadId,
            membersProfileIds: compose(map('memberProfileId'), filter<ThreadProfileMembership>({ threadId }))(data),
        })),
        uniqBy<ThreadProfileMembership>('threadId')
    )(data);

export const setThreadsMembership =
    (data: $TSFixMe): CommanderThunkAction =>
    (dispatch) => {
        const enterpriseId = getCurrentEnterpriseId();
        const meta = { scope: enterpriseId };
        const entities = mapMembers(data);

        return dispatch(createAction(THREADS_MEMBERSHIP_FETCH_SUCCEEDED, { entities }, meta));
    };

export const threadsMembershipReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: THREADS_MEMBERSHIP_FETCH_SUCCEEDED,
});
